import { getWebsite, hasSsrCodeInstalled, isWixWebsite } from '@va/dashboard/selectors/core';
import { createSelector } from 'reselect';

export const isTrackingCodeInstalled = createSelector(
  [getWebsite, isWixWebsite, hasSsrCodeInstalled],
  (website, isWix, hasSsrCode) => {
    const fFlags = website.frontendFlags;

    if (isWix) {
      return hasSsrCode as boolean;
    }

    return fFlags?.['trackingCodeInstalled'] as boolean;
  },
);
